// removed by extract-text-webpack-plugin
module.exports = {"sidebar-container":"Sidebar__sidebar-container___3epCY","left":"Sidebar__left___11rS3","top":"Sidebar__top___37hrn","expanded":"Sidebar__expanded___1X15p"};